module.exports = __webpack_public_path__ + "static/media/danger.2f305e3e.png";